export interface DietCombinationCounts {
  [key: string]: number;
}

export interface CategoryValidation {
  slug: string;
  counts: DietCombinationCounts;
}

export interface ValidCombinations {
  [categoryId: string]: CategoryValidation;
}

export const validCombinations: ValidCombinations = {
  "BI-2": {
    "slug": "asiatische-kueche",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-3": {
    "slug": "italienische-kueche",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 0,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-4": {
    "slug": "salate",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 0,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-5": {
    "slug": "fleisch",
    "counts": {
      "none": 1,
      "vegan": 0,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 0,
      "vegan+vegetarisch": 0,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-6": {
    "slug": "vegetarisch",
    "counts": {
      "none": 0
    }
  },
  "BI-7": {
    "slug": "vegan",
    "counts": {
      "none": 0
    }
  },
  "BI-8": {
    "slug": "hauptspeise",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-9": {
    "slug": "vorspeise",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-10": {
    "slug": "nachspeise",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-11": {
    "slug": "suppen",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-12": {
    "slug": "nudeln-pasta",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-13": {
    "slug": "grillen",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 0,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-14": {
    "slug": "kindergerichte",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 0,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-15": {
    "slug": "snacks-kleine-gerichte",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-16": {
    "slug": "fisch-meeresfruechte",
    "counts": {
      "none": 1,
      "vegan": 0,
      "glutenfrei": 0,
      "glutenfrei+vegan": 0,
      "vegetarisch": 0,
      "vegan+vegetarisch": 0,
      "glutenfrei+vegetarisch": 0,
      "glutenfrei+vegan+vegetarisch": 0
    }
  },
  "BI-17": {
    "slug": "fruehstueck",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-18": {
    "slug": "baeckerei-kekse",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 0,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-19": {
    "slug": "kuchen-torten",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-20": {
    "slug": "getraenke",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 0,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-21": {
    "slug": "auflauf",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 0,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-22": {
    "slug": "oesterreichische-kueche",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-23": {
    "slug": "internationale-kueche",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 0,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-24": {
    "slug": "heissluftfritteuse",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 0,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-25": {
    "slug": "ostern",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 0,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-26": {
    "slug": "muttertag",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 0,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-27": {
    "slug": "eis",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 0,
      "glutenfrei+vegan": 1,
      "vegetarisch": 0,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 0,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-28": {
    "slug": "weihnachten",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-29": {
    "slug": "halloween",
    "counts": {
      "none": 1,
      "vegan": 0,
      "glutenfrei": 0,
      "glutenfrei+vegan": 0,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-30": {
    "slug": "reis",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  },
  "BI-31": {
    "slug": "beilagen",
    "counts": {
      "none": 1,
      "vegan": 1,
      "glutenfrei": 1,
      "glutenfrei+vegan": 1,
      "vegetarisch": 1,
      "vegan+vegetarisch": 1,
      "glutenfrei+vegetarisch": 1,
      "glutenfrei+vegan+vegetarisch": 1
    }
  }
};
